import request from '@/utils/request'

let uacApi = {
  /*项目列表*/
  list(data, errorback) {
    return request._post('/shop/plus.uac.Index/index', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.uac.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.uac.Setting/getSetting', data, errorback);
  },
}
export default uacApi;



// WEBPACK FOOTER //
// ./src/api/uac.js